const CONSENT_KEY = 'draughts-cookie-consent';

export type CookieConsent = {
  analytics: boolean;
  timestamp: string;
};

export function getConsent(): CookieConsent | null {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as CookieConsent;
  } catch {
    return null;
  }
}

export function setConsent(analytics: boolean): void {
  const consent: CookieConsent = {
    analytics,
    timestamp: new Date().toISOString(),
  };
  localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
}

export function hasConsented(): boolean {
  return getConsent() !== null;
}

export function isAnalyticsAllowed(): boolean {
  const consent = getConsent();
  return consent?.analytics ?? false;
}
